<template>
  <div class="pt-32 pb-16">
    <ContentWrapper>
      <h1 class="text-3xl md:text-4xl font-headings font-bold text-primary-900">
        {{ pageTitle }}
      </h1>
      <p v-if="lead" class="mt-4 text-lg text-gray-600 max-w-2xl">
        {{ lead }}
      </p>
    </ContentWrapper>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ContentWrapper from '@/components/Layouts/ContentWrapper.vue'

const route = useRoute()
const pageTitle = computed(() => route.meta.pageTitle || '')
const lead = computed(() => route.meta.lead || '')
</script>
